import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import Hidden from '@material-ui/core/Hidden';
import MapImage from '../images/programming_world_map.jpg';
import Snackbar, { openSnackbar } from './utils/Snackbar';
import axios from '../axios/axios';
import { validateEmail } from "../utils/functions";

const styles = theme => ({
    root: {
        backgroundImage: `url(${MapImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100%'
    },
    container: {
        width: '90%',
        margin: '0 auto',
        padding: '30px 10px'
    },
    heroContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    line1: {
        fontSize: '30px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    line2: {
        fontSize: '18px',
        margin: '15px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    card: {
        padding: '20px',
        textAlign: 'center'
    },
    textField: {
        margin: '10px 0'
    },
    button: {
        margin: '10px 0',
    },
});

class ContactUs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            mobile: "",
            email: "",
            message: "",
            loader: false
        }
    }

    onInpuFieldChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        if (this.state.name === "") {
            openSnackbar({ message: "Please enter Name", variant: "info" });
        } else if (this.state.mobile === "" || this.state.mobile.length > 10 || this.state.mobile.length < 10) {
            openSnackbar({ message: "Please enter valid Mobile number", variant: "info" });
        } else if (!validateEmail(this.state.email)) {
            openSnackbar({ message: "Please enter valid Email Address", variant: "info" });
        } else if (this.state.message === "") {
            openSnackbar({ message: "Please enter your Message", variant: "info" });
        } else {
            this.setState({
                loader: true
            });
            axios.post("contact/contactUs", this.state)
                .then(result => {
                    if (result.status === 200) {
                        if (result.data.success) {
                            openSnackbar({ message: "Thank you for contacting us!", variant: "success" });
                            this.setState({
                                name: "",
                                mobile: "",
                                email: "",
                                message: ""
                            });
                        } else {
                            openSnackbar({ message: result.data.msg, variant: "error" });
                        }
                    } else {
                        openSnackbar({ message: "Something went wrong", variant: "error" });
                    }
                    this.setState({
                        loader: false
                    })
                }).catch(exception => {
                    this.setState({
                        loader: false
                    })
                    openSnackbar({ message: "Something went wrong", variant: "error" });
                });
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div id={this.props.id} className={classes.root}>
                <Snackbar />
                <section className={classes.container}>
                    <Grid container spacing={24}>
                        <Hidden only={"xs"}>
                            <Grid container justify="center" item xs={12} sm={6} lg={8}>
                                {/* <div className={classes.heroContent}>
                                    <Typography variant="h5" className={classes.line1}>Contact Us</Typography>
                                    <Typography variant="body1" className={classes.line2}>Have a project for us, small or big, our team of experts will handle it for you. Click on the button below to start your first project</Typography>
                                </div> */}
                            </Grid>
                        </Hidden>
                        <Grid item xs={12} sm={6} lg={4}>
                            <Card className={classes.card}>
                                <Typography variant="h5" className={classes.line1}>Contact Us</Typography>
                                <TextField
                                    label="Name"
                                    name="name"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    className={classes.textField}
                                    value={this.state.name}
                                    onChange={this.onInpuFieldChange}
                                    inputProps={{ maxLength: 40 }}
                                />
                                <TextField
                                    label="Mobile"
                                    name="mobile"
                                    type="tel"
                                    fullWidth
                                    variant="outlined"
                                    className={classes.textField}
                                    value={this.state.mobile}
                                    onChange={this.onInpuFieldChange}
                                    inputProps={{ maxLength: 10 }}
                                />
                                <TextField
                                    label="Email"
                                    name="email"
                                    type="email"
                                    fullWidth
                                    variant="outlined"
                                    className={classes.textField}
                                    value={this.state.email}
                                    onChange={this.onInpuFieldChange}
                                    inputProps={{ maxLength: 50 }}
                                />
                                <TextField
                                    label="Message"
                                    name="message"
                                    type="text"
                                    multiline
                                    rows="3"
                                    fullWidth
                                    variant="outlined"
                                    className={classes.textField}
                                    value={this.state.message}
                                    onChange={this.onInpuFieldChange}
                                    inputProps={{ maxLength: 300 }}
                                />
                                {
                                    this.state.loader ?
                                        <CircularProgress className={classes.progress} color="secondary" /> :
                                        <Button onClick={this.onFormSubmit} variant="outlined" color="secondary" className={classes.button}>
                                            Send</Button>
                                }
                            </Card>
                        </Grid>
                    </Grid>
                </section>
            </div>
        );
    }
}

ContactUs.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ContactUs);